module.exports = __webpack_public_path__ + "static/media/up-arrow.319fb693.svg";